import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import IcCheckIcon from '@/assets/icons/Check.svg?react';
import getLegalUrl from '@/utils/getLegalUrl';
import styles from './ConsentCheckbox.module.scss';

interface ConsentCheckboxProps {
  checked: boolean;
  onToggle: () => void;
}

const ConsentCheckbox = ({ checked, onToggle }: ConsentCheckboxProps) => {
  const { i18n } = useTranslation(['auth']);
  const lang = i18n.language ?? 'en';

  return (
    <div className={styles.consent}>
      <button
        type="button"
        id="consent"
        role="checkbox"
        aria-checked={checked}
        className={styles.checkboxRoot}
        value="yes"
        onClick={onToggle}
      >
        {checked && (
          <span data-state="checked">
            <IcCheckIcon className={styles.checkboxIndicator} />
          </span>
        )}
      </button>
      <label htmlFor="consent" className={styles.label}>
        <Trans i18nKey="auth:consentCheckbox">
          <Link
            to={getLegalUrl('terms', lang)}
            className={styles.link}
            target="_blank"
          />
          <Link
            to={getLegalUrl('privacy', lang)}
            target="_blank"
            className={styles.link}
          />
        </Trans>
      </label>
    </div>
  );
};

export default ConsentCheckbox;
